module.exports = __webpack_public_path__ + "static/media/rg-250x251.e8003002.png";